import { ROLE_NAMES } from "src/consts/role";
import { setUserId } from "src/helpers/amplitude/analytics-helpers";
import { forwardLogout } from "src/helpers/auth";
import { saveUserRole } from "src/helpers/role";
import { removeSentryUser, setSentryUser } from "src/helpers/sentry";
import AuthenticationAPI from "src/api/new-interfaces/live/authentication";
import NewVerificationAPI from "src/api/new-interfaces/live/verification";
import NewVerificationsAPI from "src/api/new-interfaces/live/verifications";
import NewCompanyAPI from "src/api/new-interfaces/live/company";
import eventBus from "src/helpers/eventBus";

export const FETCH_USER_DATA = "FETCH_USER_DATA,";
export const SUCCESS_FETCH_USER_DATA = "SUCCESS_FETCH_USER_DATA,";
export const FAILED_FETCH_USER_DATA = "FAILED_FETCH_USER_DATA,";
export const FETCH_USER_VERIFICATION_DATA = "FETCH_USER_VERIFICATION_DATA";
export const SUCCESS_FETCH_USER_VERIFICATION_DATA = "SUCCESS_FETCH_USER_VERIFICATION_DATA";
export const FAILED_FETCH_USER_VERIFICATION_DATA = "FETCH_USER_VERIFICATION_DATA";
export const FETCH_VERIFICATIONS = "FETCH_VERIFICATIONS";
export const SUCCESS_FETCH_VERIFICATIONS = "SUCCESS_FETCH_VERIFICATIONS";
export const FAILED_FETCH_VERIFICATIONS = "FAILED_FETCH_VERIFICATIONS";
export const COMMIT_USER_ROLE = "COMMIT_USER_ROLE,";
export const UPDATE_USER_DATA = "UPDATE_USER_DATA,";
export const LOGOUT_USER = "LOGOUT_USER,";
export const FAILED_LOGOUT_USER = "FAILED_LOGOUT_USER,";
export const TOGGLE_ROUTE_CLEAN = "TOGGLE_ROUTE_CLEAN";
export const FETCH_USER_REGISTERED_COMPANIES = "FETCH_USER_REGISTERED_COMPANIES";
export const SUCCESS_FETCH_USER_REGISTERED_COMPANIES = "SUCCESS_FETCH_USER_REGISTERED_COMPANIES";
export const FAILED_FETCH_USER_REGISTERED_COMPANIES = "FAILED_FETCH_USER_REGISTERED_COMPANIES";
export const FETCH_COMPANY_INFO = "FETCH_COMPANY_INFO";
export const SUCCESS_FETCH_COMPANY_INFO = "SUCCESS_FETCH_COMPANY_INFO";
export const FAILED_FETCH_COMPANY_INFO = "FAILED_FETCH_COMPANY_INFO";

export const fetchUser =
  (isLoading = true) =>
  async (dispatch, getState) => {
    if (getState().commonUser.loadingUser) return;

    if (isLoading) {
      dispatch({ type: FETCH_USER_DATA });
    }

    try {
      const infoUser = NewVerificationAPI.infoUser;
      const response = await infoUser();

      setUserId(response.id);
      eventBus.emit("user-data-fetched", response);

      dispatch({
        type: SUCCESS_FETCH_USER_DATA,
        payload: response
      });

      const userRole = response.actions_rule && response.actions_rule.message;
      saveUserRole(userRole);
      setSentryUser({ id: response.id, username: response.username });

      dispatch({
        type: COMMIT_USER_ROLE,
        payload: {
          isAdmin: userRole === ROLE_NAMES.ADMIN,
          isApprover: userRole === ROLE_NAMES.APPROVER,
          isMaker: userRole === ROLE_NAMES.MAKER,
          isDeveloper: userRole === ROLE_NAMES.DEVELOPER,
          isExecutor: userRole === ROLE_NAMES.EXECUTOR,
          isReviewer: userRole === ROLE_NAMES.REVIEWER,
          isDepositAdmin: userRole === ROLE_NAMES.DEPOSIT_ADMIN,
          isCustomerService: userRole === ROLE_NAMES.CUSTOMER_SERVICE,
          isChecker: userRole === ROLE_NAMES.CHECKER,
          isOwner: response?.current_user?.id === response?.company?.owner_id
        }
      });
    } catch (errors) {
      dispatch({ type: FAILED_FETCH_USER_DATA, payload: errors });
    }
  };

export const updateUser = (newUser) => ({
  type: UPDATE_USER_DATA,
  payload: newUser
});

export const removeUser = () => ({
  type: UPDATE_USER_DATA,
  payload: {}
});

export const logoutUser = () => async (dispatch) => {
  try {
    removeSentryUser();
    forwardLogout();
    dispatch({ type: LOGOUT_USER });
  } catch (errors) {
    forwardLogout();
    removeSentryUser();
    dispatch({ type: FAILED_LOGOUT_USER, payload: errors });
  }
};

export const setRouteClean = (value) => ({
  type: TOGGLE_ROUTE_CLEAN,
  payload: value
});

export const fetchVerificationInfo = () => {
  return async (dispatch) => {
    dispatch({ type: FETCH_USER_VERIFICATION_DATA });
    try {
      const verificationInfo = NewVerificationAPI.verificationInfo;
      const data = await verificationInfo();
      dispatch({ type: SUCCESS_FETCH_USER_VERIFICATION_DATA, payload: data });
    } catch (errors) {
      dispatch({ type: FAILED_FETCH_USER_VERIFICATION_DATA, payload: errors });
    }
  };
};

export const fetchVerifications = () => {
  return async (dispatch) => {
    dispatch({ type: FETCH_VERIFICATIONS });
    try {
      const data = await NewVerificationsAPI.getVerifications();
      dispatch({ type: SUCCESS_FETCH_VERIFICATIONS, payload: data?.data });
    } catch (errors) {
      dispatch({ type: FAILED_FETCH_VERIFICATIONS, payload: errors });
    }
  };
};

export const fetchUserRegisteredCompanies = (token) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_USER_REGISTERED_COMPANIES });
    try {
      const getRegisteredCompanies = AuthenticationAPI.getRegisteredCompanies;
      const data = await getRegisteredCompanies(token);
      dispatch({ type: SUCCESS_FETCH_USER_REGISTERED_COMPANIES, payload: data });
    } catch (errors) {
      dispatch({ type: FAILED_FETCH_USER_VERIFICATION_DATA, payload: errors });
    }
  };
};

export const fetchCompanyInfo = () => {
  return async (dispatch) => {
    dispatch({ type: FETCH_COMPANY_INFO });
    try {
      const data = await NewCompanyAPI.getCompanyInfo();
      dispatch({ type: SUCCESS_FETCH_COMPANY_INFO, payload: data?.data });
    } catch (errors) {
      dispatch({ type: FAILED_FETCH_COMPANY_INFO, payload: errors });
    }
  };
};
